import { useState, useEffect } from 'react';

export default function HeroSection({ onDonateClick }: { onDonateClick: () => void }) {
  const [supporters, setSupporters] = useState(0);
  const [amount, setAmount] = useState(0);
  const [daysLeft, setDaysLeft] = useState(0);

  useEffect(() => {
    // 후원자 수 카운팅 (0 -> 247)
    const supportersInterval = setInterval(() => {
      setSupporters(prev => {
        if (prev >= 247) {
          clearInterval(supportersInterval);
          return 247;
        }
        return prev + 3;
      });
    }, 20);

    // 후원 금액 카운팅 (0 -> 30,000)
    const amountInterval = setInterval(() => {
      setAmount(prev => {
        if (prev >= 30000) {
          clearInterval(amountInterval);
          return 30000;
        }
        return prev + 500;
      });
    }, 20);

    // 남은 일수 카운팅 (0 -> 45)
    const daysInterval = setInterval(() => {
      setDaysLeft(prev => {
        if (prev >= 45) {
          clearInterval(daysInterval);
          return 45;
        }
        return prev + 1;
      });
    }, 30);

    return () => {
      clearInterval(supportersInterval);
      clearInterval(amountInterval);
      clearInterval(daysInterval);
    };
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/115ff32060f27bb5c4804dee85166ab9.jpg"
          alt="신공 영화 배경"
          className="w-full h-full object-cover object-top"
        />
      </div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      
      {/* 카운팅 애니메이션 통계 */}
      <div className="absolute top-24 left-1/2 -translate-x-1/2 w-full max-w-4xl px-8">
        <div className="grid grid-cols-3 gap-6">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center border border-white/20">
            <div className="text-4xl font-black text-amber-400 mb-2">
              {supporters.toLocaleString()}명
            </div>
            <div className="text-sm text-white/80 font-medium">후원자</div>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center border border-white/20">
            <div className="text-4xl font-black text-amber-400 mb-2">
              {amount.toLocaleString()}원
            </div>
            <div className="text-sm text-white/80 font-medium">모인 금액</div>
          </div>
          
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 text-center border border-white/20">
            <div className="text-4xl font-black text-amber-400 mb-2">
              {daysLeft}일
            </div>
            <div className="text-sm text-white/80 font-medium">남은 기간</div>
          </div>
        </div>
      </div>
      
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl px-8 text-center">
        <div className="space-y-6">
          <h1 
            className="text-8xl font-black text-white tracking-tight"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            신공<span className="text-6xl align-super ml-2">(新功)</span>
          </h1>
          
          <p 
            className="text-3xl text-white/90 font-light italic"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            잊혀진 영웅의 부활
          </p>
          
          <p 
            className="text-xl text-amber-400 font-medium mt-8"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            이 시대가 간절히 바라던, 당신과 함께 만드는 새로운 전설
          </p>
          
          <div className="flex items-center justify-center gap-4 mt-12">
            <button
              onClick={onDonateClick}
              className="bg-amber-600 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-amber-700 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              지금 후원하기
              <i className="ri-arrow-right-line"></i>
            </button>
            <button className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-gray-900 transition-all flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <i className="ri-play-fill"></i>
              예고편 보기
            </button>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="text-white text-sm flex flex-col items-center gap-2">
          <span className="text-xs uppercase tracking-wider">Scroll</span>
          <i className="ri-arrow-down-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}